(function () {
  'use strict';

  var ANCHOR_ID = 'klaviyo-bis-anchor';
  var READY_TIMEOUT = 5000;
  var POLL_INTERVAL = 100;

  function getTrigger() {
    var anchor = document.getElementById(ANCHOR_ID);
    return anchor ? anchor.querySelector('.klaviyo-bis-trigger') : null;
  }

  function whenTriggerReady(callback) {
    var trigger = getTrigger();
    if (trigger) {
      callback(trigger);
      return;
    }

    var waited = 0;
    var timer = setInterval(function () {
      var el = getTrigger();
      waited += POLL_INTERVAL;
      if (el) {
        clearInterval(timer);
        callback(el);
      } else if (waited >= READY_TIMEOUT) {
        clearInterval(timer);
        callback(null);
      }
    }, POLL_INTERVAL);
  }

  function syncVariantId(variantId) {
    if (!variantId || typeof window.history.replaceState !== 'function') return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('variant') === String(variantId)) return;
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ path: url.href }, '', url.href);
  }

  window.openKlaviyoBackInStock = function (variantId, button) {
    if (button) button.classList.add('is-loading');

    syncVariantId(variantId);

    whenTriggerReady(function (trigger) {
      if (button) button.classList.remove('is-loading');
      if (!trigger) return;

      document.body.dispatchEvent(new Event('change', { bubbles: true }));
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  };

  window.isKlaviyoBackInStockAvailable = function () {
    return !!document.getElementById(ANCHOR_ID);
  };

  function watchModal() {
    var iframe = document.getElementById('klaviyo-bis-iframe');
    if (!iframe || iframe.dataset.overlayBound === 'true') return;
    iframe.dataset.overlayBound = 'true';

    var sync = function () {
      var isOpen = window.getComputedStyle(iframe).display !== 'none';
      document.body.classList.toggle('klaviyo-bis-open', isOpen);
    };

    new MutationObserver(sync).observe(iframe, { attributes: true, attributeFilter: ['style'] });
    sync();
  }

  whenTriggerReady(function (trigger) {
    if (trigger) watchModal();
  });

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.js-klaviyo-bis');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = button.dataset.variantId;
    if (!variantId) {
      var form = document.querySelector('.product-form-snippet form');
      var checked = form && form.querySelector('input[name="id"]:checked');
      var fallback = form && form.querySelector('input[name="id"]');
      var input = checked || fallback;
      if (input) variantId = input.value;
    }

    window.openKlaviyoBackInStock(variantId, button);
  }, true);
})();
